

























import { Component, Prop, Vue } from 'vue-property-decorator'
import debug from '@/helpers/debug'
import js2excel from 'js2excel'
import request from '@/helpers/requests'


interface SummaryRow {
    locationName: string;
    pulsemAccountId: number;
    happyCount: number|null;
    neutralCount: number|null;
    unhappyCount: number|null;
    googleCountStart: number|null;
    googleCountToday: number|null;
    googleNetGain: number|null;
}


interface Summations {
    happyTotal: number|null;
    neutralTotal: number|null;
    unhappyTotal: number|null;
    googleCountStartTotal: number|null;
    googleCountTodayTotal: number|null;
    googleNetGainTotal: number|null;
}


interface SummaryRows {
    rows: SummaryRow[];
    summations: Summations;
}


interface SummaryData {
    data: SummaryRows;
}


@Component({})
export default class TransactionTable extends Vue {
    @Prop() accountId!: number
    @Prop() beginDate!: string
    @Prop() fromDate!: string
    @Prop() toDate!: string
    summaryReport: SummaryRow[] = []
    summations: Summations|null = null
    search = ''
    loading = false
    summaryHeaders = [
        { text: 'Location', align: 'left', value: 'locationName' },
        { text: 'Pulsem Account ID', value: 'pulsemAccountId' },
        { text: 'Happy', value: 'happyCount' },
        { text: 'Neutral', value: 'neutralCount' },
        { text: 'Unhappy', value: 'unhappyCount' },
        { text: 'Google Count Start', value: 'googleCountStart' },
        { text: 'Google Count Today', value: 'googleCountToday' },
        { text: 'Google Net Gain', value: 'googleNetGain' }
    ]

    /**
     * This functions retrieves the pertinent data for the report from the endpoint using accountId and beginDate.
     * @returns { SummaryData }
     */
    async getSummaryData(): Promise<SummaryData> {
        return await request.post('/support/franchise/summary-report', {
            accountId: this.accountId,
            beginDate: this.beginDate,
            fromDate: this.fromDate,
            toDate: this.toDate
        }) as SummaryData
    }

    async compileData() {
        this.loading = true
        const data: SummaryData = await this.getSummaryData()
        this.summaryReport = data.data.rows
        this.summations = data.data.summations
        this.loading = false
    }

    /**
     * This function is responsible for the exporting of the data from the report to an excel sheet.
     * NOTE: This arranges the columns in a strange way. It sorts columns in alphabetical order.
     */
    exportToExcel() {
        const reportName = 'summary_report'
        const data = this.summaryReport
        const date = new Date().toISOString().slice(0, 10)
        const name = reportName.concat('_' + date)
        try {
            js2excel.json2excel({
                data,
                name,
                formateDate: 'yyyy/mm/dd'
            })
        } catch(e) {
            debug.error('Excel export error.')
        }
    }
}
